export function HxCard({ hover, className = "", children, ...rest }) {
  return (
    <section className={`hx-card ${hover ? "hx-card--hover" : ""} ${className}`} {...rest}>
      {children}
    </section>
  );
}

export function HxCardHead({ title, icon, right, ...rest }) {
  return (
    <div className="hx-card__head" {...rest}>
      <div className="hx-card__title">{icon}{title}</div>
      {right}
    </div>
  );
}
